import { atom } from "jotai";
import { INotification } from "library/types";

export const panelIsOpenState = atom(false);

export const notificationMessagesState = atom<INotification[] | []>([]);
